import React from 'react';
import { Box } from '@mui/material';

// Deliberately distinct from the system-table configuration; dynamic schema and CRUD remain custom-only.
export const CUSTOM_TABLE_LAYOUT_CONFIG = Object.freeze({ density: 'comfortable', stickyHeader: true, showRecordCount: true, allowDynamicColumns: true, allowCrud: true, pagination: true });

export default function CustomTableLayout({ tableId, config = CUSTOM_TABLE_LAYOUT_CONFIG, children, ...props }) {
  return <Box data-table-layout="custom" data-table-id={tableId || ''} data-table-density={config.density} sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, minWidth: 0 }} {...props}>{children}</Box>;
}
